import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getFountainConditionsData(context) {
      const response = await Vue.axios.get(`${URL_API}fountaincondition`);
      let data = response["data"];
      context.commit("updateFountainConditionsData", data);
    },
    async createFountainConditionData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}fountaincondition/store`, body, config);
      context.dispatch("getFountainConditionsData");
    },
    async pushFountainConditionData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}fountaincondition/update`, body, config);
      context.dispatch("getFountainConditionsData");
    },
    async destroyFountainConditionData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}fountaincondition/destroy`, body, config);
      context.dispatch("getFountainConditionsData");
    }
  },
  mutations: {
    updateFountainConditionsData(state, fountainConditionsData) {
      state.fountainConditionsData = fountainConditionsData;
    }
  },
  state: {
    fountainConditionsData: []
  },
  getters: {
    allFountainConditionsData(state) {
      return state.fountainConditionsData;
    }
  }
};